<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="display: flex; align-content: center; align-items: center;"
                cols="4"
                lg="6"
                md="6"
                sm="4"
            >
                <h3>Dashboard by Departament</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col 
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineSales" class="preDig_alpha">
                    <v-card-title class="text-h6 preDig d-flex justify-space-between">
                        
                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-currency-usd</v-icon>
                            <label class="pipelineLabelTitle">Sales</label>
                        </div>

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalSales }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                            <label class="pipelineLabelTitle"> | </label>
                            
                            <label class="labelHoldResumeValue alignValueRight">{{ totalValueSales }}</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdInProgress }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.SALES_IN_PROGRESS.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueInProgressFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdWaitingApproval }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.SALES_WAITING_APPROVAL.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueWaitingApprovalFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFinishProposal }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.SALES_FINISH_PROPOSAL.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueFinishProposalFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdContracted }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.SALES_CONTRACTED.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueContractedFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineDrafting" class="frontend_alpha">
                    <v-card-title class="text-h6 frontend d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-material-design</v-icon>
                            <label class="pipelineLabelTitle">Drafting</label>
                        </div>


                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue"> {{ totalDrafting }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                            <label class="pipelineLabelTitle"> | </label>
                            
                            <label class="labelHoldResumeValue alignValueRight">{{ totalValueDrafting }}</label>
                        </div>       

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDraftingReview }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.DRAFTING_REVIEW.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueDraftingReviewFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDrafting }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.DRAFTING.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueDraftingFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDraftingApproval }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.DRAFTING_APPROVAL.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueDraftingApprovalFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdDraftingFinalPlan }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.DRAFTING_FINAL_PLAN.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueDraftingFinalPlanFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdEngineering }}</label>
                            </v-col>
                            <v-col 
                                cols="7"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.DRAFTING_ENGINEERING.description }}</label>
                            </v-col>
                            <v-col 
                                cols="3"
                                class="alignValue alignValueRight"
                            >
                                <label class="pipelineLabelValue">{{ valueEngineeringFormatted }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelinePermitting" class="grading_plumbing_alpha">
                    <v-card-title class="text-h6 grading_plumbing d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-file-sign</v-icon>
                            <label class="pipelineLabelTitle">Permitting</label>
                        </div>                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue"> {{ totalPermitting }} </label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdIncomingProjects }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.PERMITTING_INCOMING_PROJECTS.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPermitFileReview }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.PERMITTING_PLAN_APPROVAL_PENDING.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdReadyToSubmit }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.PERMITTING_READY_SUBMIT.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPermitInReview }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.PERMITTING_PERMIT_REVIEW.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPermitApprovedAndIssued }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.PERMITTING_FILE_REVIEW.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            
            <v-col 
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineConstruction" class="tiledeck_alpha">
                    <v-card-title class="text-h6 tiledeck d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-account-hard-hat-outline</v-icon>
                            <label class="pipelineLabelTitle">Construction</label>
                        </div>
                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalConstruction }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <!-- <br /> -->
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title>
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPreDig }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Pre-Dig</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFrontEnd }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Front end</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdGradingPlumbing }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Grading / Plumbing</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBrickTileDeck }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Brick & Tile / Deck</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdEquipmentElectric }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Equipment / Electric</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPlaster }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Plaster</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFence }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Fence</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdBBQ }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">BBQ</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdPergola }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">Outdoor</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col 
                cols="12"
                lg="4"
                md="6"
                sm="12"
            >
                <v-card @click="goToPipelineService" class="equipment_electric_alpha">
                    <v-card-title class="text-h6 equipment_electric d-flex justify-space-between">

                        <div>
                            <v-icon left class="pipelineIconTitle">mdi mdi-account-wrench</v-icon>
                            <label class="pipelineLabelTitle">Service</label>
                        </div>                        

                        <div style="text-align: right;">
                            <label class="labelHoldResumeValue">{{ totalService }}</label>
                            <label class="labelHoldResume">Open</label>
                            <label class="pipelineLabelTitle"> | </label>
                            <label class="labelHoldResumeValue">0</label>
                            <label class="labelHoldResume">On Hold</label>
                        </div>

                    </v-card-title> 
                    <v-card-text 
                        class="pipelineDetails"
                    >
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdFireUp }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_SERVICE_FIREUP.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdAfterPlaster }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_SERVICE_AFTERPLASTER.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdTurnOver }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_SERVICE_TURNOVER.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValue">{{ qtdInspections }}</label>
                            </v-col>
                            <v-col 
                                cols="10"
                                class="alignValueLabel"
                            >
                                <label class="pipelineLabel">{{ PROJECT_STATUS.CONSTRUCTION_SERVICE_INSPECTION.description }}</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col 
                                cols="1"
                                class="alignValue"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                            <v-col 
                                cols="10"
                            >
                                <label class="pipelineLabelValueBlank">-</label>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Helpers from '@/utilities/Helpers';
    import { formaterDecimalBR } from '@/utilities/Utils';
    import { 
        PROJECT_STATUS
    } from "@/utilities/Enums";
    
    export default ({

        mixins: [Helpers],

        data: () => ({

            filter: {
                fastSearch: ''
            },

            //Sales
            qtdInProgress: 0,
            qtdWaitingApproval: 0,
            qtdFinishProposal: 0,
            qtdContracted: 0,
            valueInProgress: 0,
            valueInProgressFormatted: 0,
            valueWaitingApproval: 0,
            valueWaitingApprovalFormatted: 0,
            valueFinishProposal: 0,
            valueFinishProposalFormatted: 0,
            valueContracted: 0,
            valueContractedFormatted: 0,

            //Drafting
            qtdDraftingReview: 0,
            qtdDrafting: 0,
            qtdDraftingApproval: 0,
            qtdDraftingFinalPlan: 0,
            qtdEngineering: 0,
            qtdNeedsApproval: 0,
            valueDraftingReview: 0,
            valueDraftingReviewFormatted: 0,
            valueDrafting: 0,
            valueDraftingFormatted: 0,
            valueDraftingApproval: 0,
            valueDraftingApprovalFormatted: 0,
            valueDraftingFinalPlan: 0,
            valueDraftingFinalPlanFormatted: 0,
            valueEngineering: 0,
            valueEngineeringFormatted: 0,

            //Permitting
            qtdIncomingProjects: 0,
            qtdPermitFileReview: 0,
            qtdReadyToSubmit: 0,
            qtdPermitInReview: 0,
            qtdPermitApprovedAndIssued: 0,

            //Construction
            qtdPreDig: 0,
            qtdFrontEnd: 0,
            qtdGradingPlumbing: 0,
            qtdBrickTileDeck: 0,
            qtdEquipmentElectric: 0,
            qtdPlaster: 0,
            qtdFence: 0,
            qtdBBQ: 0,
            qtdPergola: 0,

            //Service
            qtdFireUp: 0,
            qtdAfterPlaster: 0,
            qtdTurnOver: 0,
            qtdInspections: 0,

            PROJECT_STATUS,
        }),

        computed: {
            ...mapGetters('logInModule', { userLoggedGetters: 'searchState' }),

            totalSales() {
                return parseInt(this.qtdInProgress) + 
                       parseInt(this.qtdWaitingApproval) +
                       parseInt(this.qtdFinishProposal) +
                       parseInt(this.qtdContracted);
            },

            totalValueSales() {
                const totalValue =  parseFloat(this.valueInProgress) + 
                                    parseFloat(this.valueWaitingApproval) +
                                    parseFloat(this.valueFinishProposal) +
                                    parseFloat(this.valueContracted);

                return `$ ${formaterDecimalBR(totalValue.toFixed(2))}`;
            },

            totalDrafting() {
                return parseInt(this.qtdDraftingReview) + 
                       parseInt(this.qtdDrafting) +
                       parseInt(this.qtdDraftingApproval) +
                       parseInt(this.qtdDraftingFinalPlan) +
                       parseInt(this.qtdEngineering) +
                       parseInt(this.qtdNeedsApproval);
            },

            totalValueDrafting() {
                return parseInt(this.valueDraftingReview) + 
                       parseInt(this.valueDrafting) +
                       parseInt(this.valueDraftingApproval) +
                       parseInt(this.valueDraftingFinalPlan) +
                       parseInt(this.valueEngineering);
            },

            totalPermitting() {
                return parseInt(this.qtdIncomingProjects) + 
                       parseInt(this.qtdPermitFileReview) +
                       parseInt(this.qtdReadyToSubmit) +
                       parseInt(this.qtdPermitInReview) +
                       parseInt(this.qtdPermitApprovedAndIssued);
            },

            totalConstruction() {
                return parseInt(this.qtdPreDig) + 
                       parseInt(this.qtdFrontEnd) +
                       parseInt(this.qtdGradingPlumbing) +
                       parseInt(this.qtdBrickTileDeck) +
                       parseInt(this.qtdEquipmentElectric) +
                       parseInt(this.qtdPlaster) +
                       parseInt(this.qtdFence) +
                       parseInt(this.qtdBBQ) +
                       parseInt(this.qtdPergola);
            },

            totalService() {
                return parseInt(this.qtdFireUp) + 
                       parseInt(this.qtdAfterPlaster) +
                       parseInt(this.qtdTurnOver) +
                       parseInt(this.qtdInspections);
            },          
        },

        methods: {

            async getRegistersSales() {
                const response = await this.$store.dispatch("serviceModule/ListPipelineSalesPerson");

                const listPipeline = response.listPipeline;
                const listInProgress = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.SALES_IN_PROGRESS.id)];
                if (listInProgress != null && listInProgress != undefined) {
                    this.qtdInProgress = listInProgress.length;
                    this.valueInProgress = response.totalInProgress;
                    this.valueInProgressFormatted = response.totalInProgressFormatted;
                }

                const listWaitingApproval = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.SALES_WAITING_APPROVAL.id)];
                if (listWaitingApproval != null && listWaitingApproval != undefined) {
                    this.qtdWaitingApproval = listWaitingApproval.length;
                    this.valueWaitingApproval = response.totalWaitingApproval;
                    this.valueWaitingApprovalFormatted = response.totalWaitingApprovalFormatted;
                }

                const listFinishProposal = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.SALES_FINISH_PROPOSAL.id)];
                if (listFinishProposal != null && listFinishProposal != undefined) {
                    this.qtdFinishProposal = listFinishProposal.length;
                    this.valueFinishProposal = response.totalFinishProposal;
                    this.valueFinishProposalFormatted = response.totalFinishProposalFormatted;
                }

                const listContracted = [...listPipeline.filter(pip => pip.status >= this.PROJECT_STATUS.SALES_CONTRACTED.id)];
                if (listContracted != null && listContracted != undefined) {
                    this.qtdContracted = listContracted.length;
                    this.valueContracted = response.totalContracted;
                    this.valueContractedFormatted = response.totalContractedFormatted;
                }
            },

            async getRegistersDrafting() {
                const response = await this.$store.dispatch("serviceModule/ListPipelineDrafting");

                const listPipeline = response.listPipeline;

                const listDraftingReview = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.DRAFTING_REVIEW.id)];
                if (listDraftingReview != null && listDraftingReview != undefined) {
                    this.qtdDraftingReview = listDraftingReview.length;
                    this.valueDraftingReview = response.totalDraftingReview;
                    this.valueDraftingReviewFormatted = response.totalDraftingReviewFormatted;
                }

                const listDrafting = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.DRAFTING.id)];
                if (listDrafting != null && listDrafting != undefined) {
                    this.qtdDrafting = listDrafting.length;
                    this.valueDrafting = response.totalDrafting;
                    this.valueDraftingFormatted = response.totalDraftingFormatted;
                }

                const listDraftingApproval = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.DRAFTING_APPROVAL.id)];
                if (listDraftingApproval != null && listDraftingApproval != undefined) {
                    this.qtdDraftingApproval = listDraftingApproval.length;
                    this.valueDraftingApproval = response.totalDraftingApproval;
                    this.valueDraftingApprovalFormatted = response.totalDraftingApprovalFormatted;
                }

                const listDraftingFinalPlan = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.DRAFTING_FINAL_PLAN.id)];
                if (listDraftingFinalPlan != null && listDraftingFinalPlan != undefined) {
                    this.qtdDraftingFinalPlan = listDraftingFinalPlan.length;
                    this.valueDraftingFinalPlan = response.totalDraftingFinalPlan;
                    this.valueDraftingFinalPlanFormatted = response.totalDraftingFinalPlanFormatted;
                }

                const listEngineering = [...listPipeline.filter(pip => pip.status >= this.PROJECT_STATUS.DRAFTING_ENGINEERING.id)];
                if (listEngineering != null && listEngineering != undefined) {
                    this.qtdEngineering = listEngineering.length;
                    this.valueEngineering = response.totalEngineering;
                    this.valueEngineeringFormatted = response.totalEngineeringFormatted;
                }
            },

            async getRegistersPermitting(listPipeline) {

                const listIncomingProjects = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.PERMITTING_INCOMING_PROJECTS.id)];
                if (listIncomingProjects != null && listIncomingProjects != undefined) {
                    this.qtdIncomingProjects = listIncomingProjects.length;
                }

                const listPermitFileReview = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.PERMITTING_PLAN_APPROVAL_PENDING.id)];
                if (listPermitFileReview != null && listPermitFileReview != undefined) {
                    this.qtdPermitFileReview = listPermitFileReview.length;
                }

                const listReadyToSubmit = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.PERMITTING_READY_SUBMIT.id)];
                if (listReadyToSubmit != null && listReadyToSubmit != undefined) {
                    this.qtdReadyToSubmit = listReadyToSubmit.length;
                }

                const listPermitInReview = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.PERMITTING_PERMIT_REVIEW.id)];
                if (listPermitInReview != null && listPermitInReview != undefined) {
                    this.qtdPermitInReview = listPermitInReview.length;
                }

                const listPermitApprovedAndIssued = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.PERMITTING_FILE_REVIEW.id)];
                if (listPermitApprovedAndIssued != null && listPermitApprovedAndIssued != undefined) {
                    this.qtdPermitApprovedAndIssued = listPermitApprovedAndIssued.length;
                }
            },

            async getRegistersConstruction(listPipeline) {
                
                let listPreDig = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_BRICKANDTILEINSTALL.id)];
                if (listPreDig != null && listPreDig != undefined) {
                    this.qtdPreDig = listPreDig.length;
                }

                let listFrontEnd = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_FrontEnd.id)];
                if (listFrontEnd != null && listFrontEnd != undefined) {
                    this.qtdFrontEnd = listFrontEnd.length;
                }

                let listGradingPlumbing = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_GradingPlumbing.id)];
                if (listGradingPlumbing != null && listGradingPlumbing != undefined) {
                    this.qtdGradingPlumbing = listGradingPlumbing.length;
                }

                let listBrickTileDeck = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_BrickTileDeck.id)];
                if (listBrickTileDeck != null && listBrickTileDeck != undefined) {
                    this.qtdBrickTileDeck = listBrickTileDeck.length;
                }

                let listEquipmentElectric = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_BRICKTILE_DECKINSPECTION.id)];
                if (listEquipmentElectric != null && listEquipmentElectric != undefined) {
                    this.qtdEquipmentElectric = listEquipmentElectric.length;
                }
            },

            async getRegistersService(listPipeline) {
                
                const listFireUp = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_SERVICE_FIREUP.id)];
                if (listFireUp != null && listFireUp != undefined) {
                    this.qtdFireUp = listFireUp.length;
                }

                const listAfterPlaster = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_SERVICE_AFTERPLASTER.id)];
                if (listAfterPlaster != null && listAfterPlaster != undefined) {
                    this.qtdAfterPlaster = listAfterPlaster.length;
                }

                const listTurnOver = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_SERVICE_TURNOVER.id)];
                if (listTurnOver != null && listTurnOver != undefined) {
                    this.qtdTurnOver = listTurnOver.length;
                }

                const listInspections = [...listPipeline.filter(pip => pip.status == this.PROJECT_STATUS.CONSTRUCTION_SERVICE_INSPECTION.id)];
                if (listInspections != null && listInspections != undefined) {
                    this.qtdInspections = listInspections.length;
                }
            },

            async getRegisters() {

                this.getRegistersSales();
                this.getRegistersDrafting();

                const response = await this.$store.dispatch("serviceModule/ListPipelineConstruction");

                if (response != null && response != undefined) {

                    if (response.listPipeline && response.listPipeline != null && response.listPipeline != undefined) {
                        
                        this.getRegistersPermitting(response.listPipeline);
                        this.getRegistersConstruction(response.listPipeline);
                        this.getRegistersService(response.listPipeline);
                    }
                }
            },

            async goToPipelineSales() {
                this.$router.push({ path: "/sales/pipeline" });
            },

            async goToPipelineDrafting() {
                this.$router.push({ path: "/drafting/pipeline" });
            },

            async goToPipelinePermitting() {
                this.$router.push({ path: "/permitting/pipeline" });
            },

            async goToPipelineConstruction() {
                this.$router.push({ path: "/construction/dashboard" });
            },

            async goToPipelineService() {
                this.$router.push({ path: "/service/salesPipeline" });
            },
        },

        async created() {
            this.showLoading();
            await this.getRegisters();
            this.hideLoading();
        },
    })
</script>

<style scoped>
    label {
        font-size: 14px !important;
        color: #5e5e5e;
    }
</style>